import { Avatar, AvatarProps, forwardRef } from '@bonusly/design-system';

import User from '../../types/user';

interface UserAvatarProps extends AvatarProps {
	onClick?: VoidFunction;
	user: Pick<User, 'display_name' | 'profile_pic_url'>;
}

export const UserAvatar = forwardRef<UserAvatarProps, 'span'>(({ user, ...rest }, ref) => (
	<Avatar name={user.display_name} ref={ref} src={user.profile_pic_url} {...rest} />
));
